<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>Расходы Заявителя по проекту по статьям</td>
            <td style="width: 15%">
              Всего расходы, тыс. руб.
            </td>
            <td style="width: 15%">Уже произведенные расходы, тыс. руб.</td>
            <td style="width: 15%">
              Планируемые расходы до конца проекта, тыс. руб.
            </td>
            <td style="width: 15%">
              В т.ч. расходы, планируемые за счет займа, тыс. руб.
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in budgets">
            <td>
              <span v-if="item.isChild" style="margin-left: 40px;display: block"
                >{{ item.name }}
                <input
                  v-if="item.ID === 202 || item.ID === 211 || item.ID === 216"
                  disabled
                  :value="item.data.UF_OTHER_NAME"
                  class="sel-dropdown i-main-style"
                  style="width: 300px"
              /></span>
              <span v-else>{{ item.name }}</span>
            </td>
            <td>
              <input
                type="text"
                v-if="item.data"
                style="width: 90%"
                class="i-main-style i-co-executor-style"
                v-model="item.data.UF_TOTAL_EXP"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
            <td>
              <input
                type="text"
                style="width: 90%"
                v-if="item.data"
                class="i-main-style"
                v-model="item.data.UF_ALREADY_EXP"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
            <td>
              <input
                type="text"
                style="width: 90%"
                v-if="item.data"
                class="i-main-style i-co-executor-style"
                v-model="item.data.UF_PLANNED_EXP"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
            <td>
              <input
                type="text"
                style="width: 90%"
                v-if="item.data"
                class="i-main-style i-co-executor-style"
                v-model="item.data.UF_PLANNED_ZAIM_EXP"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "BudgetOld",
  data() {
    return {
      budgets: []
    };
  },
  async created() {
    await this.$store.dispatch(FETCH_DIRECTORY, ["tree/budget_article"]);
    Object.keys(this.project.BUDGET_OLD.BUDGET_ARTICLE_ID).map(function(blid) {
      let budgetList = this.project.BUDGET_OLD.BUDGET_ARTICLE_ID[blid];
      Object.keys(budgetList).map(function(bid) {
        let budget = budgetList[bid].UF_BUDGET_ARTICLE_ID;
        this.directory.tree_budget_article.forEach(function(b) {
          let isChild = b.CHILD.length > 1;
          b.CHILD.forEach(function(c) {
            if (c.ID === budget) {
              if (isChild) {
                let pi = false;
                this.budgets.forEach(function(br) {
                  if (br.ID === b.ID) {
                    pi = true;
                  }
                });
                if (!pi) {
                  this.budgets.push({
                    ID: b.ID,
                    name: b.NAME,
                    code: b.CODE,
                    isChild: false,
                    haveParent: true
                  });
                }
              }
              let budgetItem = {
                ID: c.ID,
                name: c.NAME,
                code: c.CODE,
                isChild: isChild,
                haveParent: false,
                data: this.project.BUDGET_OLD.items[c.ID]
              };
              this.budgets.push(budgetItem);
            }
          }, this);
        }, this);
      }, this);
    }, this);
  },
  computed: {
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
